import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Events } from '../provider/events.service';
import { AuthService } from '../services/auth.service'; // Import AuthService
import { take, tap } from 'rxjs/operators'; // Import operators
import { Observable } from 'rxjs';
import { RouterStateTrackerService } from '../services/router-state-tracker.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private events: Events,
    private toastCtrl: ToastController,
    private translate: TranslateService,
    private router: Router,
    private routerStateTrackerService: RouterStateTrackerService,
    private authService: AuthService, // Inject AuthService
  ) {}

  public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.isAuthenticated$.pipe(
      take(1), // Take only the first emission and complete
      tap((isAuthenticated) => {
        if (!isAuthenticated) {
          // Only publish the event and potentially show toast if not authenticated
          this.events.publish('user:login', { user: null, time: new Date() });
          // Optional toast message, uncomment if desired:
          // this.toastCtrl.create({
          //     message: this.translate.instant('login_to_access_app'),
          //     duration: 2300,
          //     position: 'top',
          //     color: 'light'
          // }).then(toastElem => toastElem.present());

          // We are guarding, so if not authenticated, navigate away.
          // The app.component's handleAuthEvent will likely navigate to '/onboarding'.
          // You might want to explicitly navigate here if the app.component's navigation isn't immediate enough.
          this.navigateToPage('/onboarding', { state: 'unAuthenticated', item: '' });
        }
      }),
    );
  }
  navigateToPage(page: string, data: any = { test: 'from AuthGuard' }): void {
    const main = this.routerStateTrackerService.combinedData;

    this.routerStateTrackerService.navigateWithPreExitAnimation(page, data);
    // this.router.navigate([page], navigationExtras);
  }
}
